module.exports = __webpack_public_path__ + "static/media/nokukhanya_chili.50054139.jpeg";